import { Auth } from 'aws-amplify';

// Validate required environment variables on startup
export const validateEnvVars = () => {
  const requiredVars = [
    'REACT_APP_REGION',
    'REACT_APP_USER_POOL_ID',
    'REACT_APP_USER_POOL_CLIENT_ID',
    'REACT_APP_IDENTITY_POOL_ID',
    'REACT_APP_API_URL'
  ];

  const missingVars = requiredVars.filter(varName => !process.env[varName]);
  
  if (missingVars.length > 0) {
    console.error(`Missing required environment variables: ${missingVars.join(', ')}`);
    return false;
  }
  
  return true;
};

// Setup token refresh to prevent session timeouts
export const setupTokenRefresh = () => {
  // Check session validity every 15 minutes
  const REFRESH_INTERVAL = 15 * 60 * 1000;
  
  const refreshAuthToken = async () => {
    try {
      // First check if we have a current user - if not, don't try to refresh
      try {
        // This won't throw an exception if we're authenticated
        await Auth.currentAuthenticatedUser();
      } catch (userError) {
        // If there's no authenticated user, silently exit without errors
        return;
      }
      
      // If we get here, we have an authenticated user, so try to refresh the token
      const currentSession = await Auth.currentSession();
      // If token is expiring within 60 minutes, refresh it
      const expirationTime = currentSession.getIdToken().getExpiration() * 1000;
      const currentTime = Date.now();
      const timeUntilExpiration = expirationTime - currentTime;
      
      if (timeUntilExpiration < 60 * 60 * 1000) {
        await Auth.currentAuthenticatedUser({ bypassCache: true });
        console.log('Auth token refreshed successfully');
      }
    } catch (error) {
      // Log error but suppress it in console if it's just about no current user
      if (error.message !== 'No current user' && !error.message?.includes('No current user')) {
        console.error('Failed to refresh auth token:', error);
      }
    }
  };

  // Initial check with a small delay to allow auth to initialize
  setTimeout(refreshAuthToken, 2000);
  
  // Setup interval for periodic checks
  return setInterval(refreshAuthToken, REFRESH_INTERVAL);
};
